import { useGeneralBottomSheetModal } from '@euler/functions/useBottomSheetModal';
import { VehicleServiceInfo } from '@euler/services';
import { BottomSheetModal } from '@gorhom/bottom-sheet';
import { memo } from 'react';
import { HistoricalServiceInfoNavigator } from './Navigator';

export const HistoricalServiceInfoBottomSheet = memo(
  ({
    show,
    serviceInfo,
    onDismiss,
  }: {
    show: boolean;
    onDismiss: () => void;
    serviceInfo: VehicleServiceInfo | undefined;
  }) => {
    const { bottomSheetModalRef, ...bottomSheetProps } =
      useGeneralBottomSheetModal({
        show,
        minSnapPoint: '45%',
        mediumSnapPoint: '70%',
        onDismiss,
      });

    return (
      <BottomSheetModal ref={bottomSheetModalRef} {...bottomSheetProps}>
        {serviceInfo != null ? (
          <HistoricalServiceInfoNavigator
            serviceInfo={serviceInfo}
            onCancel={() => bottomSheetModalRef.current?.dismiss()}
          />
        ) : null}
      </BottomSheetModal>
    );
  },
);
